export const CSS_PARSING_ERROR_MESSAGE =
  'Your CSS style is incorrect. Please check your syntax and try again';
